module.exports = __webpack_public_path__ + "components/flag/static/square/zw-06d96916ff98c96811c25d0ffb765da4.svg";